import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const newsletterslogsView = lazy(() => import('../../container/crud/newslettersDownloads/Index'));
// const VinsAdd = lazy(() => import('../../container/crud/vins/Add'));


const PagesRoute = () => {
  const { path } = useRouteMatch();
  //<Route path={`${path}/dataTable`} component={DataTable} />
  return (
    <Switch>
      <Route path={`${path}`} component={newsletterslogsView} />
      {/* <Route path={`${path}/crud/vins-add`} component={VinsAdd} /> */}
      {/* <Route exact path={`${path}/crud/vins-edit/:id`} component={VinsAdd} /> */}
    </Switch>
  );
};

export default PagesRoute;